import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import User from '@/shared/models/User';
import Fluid, { FluidData } from '../models/Fluid';
import FluidSpecification from '../models/FluidSpecification';

const SCHEMA = {
  id: 'id',
  typeId: 'fluidId',
  description: 'description',
  isLiquid: 'isLiquid',
  unit: 'unit',
  quantity: 'quantity',
  productCode: 'productCode',
};

const FLUID_SCHEMA  = {
  ...SCHEMA,
  maxValue: 'maxValue',
  stepValue: 'stepValue',
  specifications: (data: any) => parseSpecifications(data.specifications),
  modifiedBy: (data: any) => User.withFullNameAndAvatar(data.modifiedByName, data.modifiedByAvatar),
};

const REPLENISHED_SCHEMA = {
  ...SCHEMA,
  specifications: (data: any) => [data.specification].filter(Boolean).map(FluidSpecification.withDescription),
};

const SPECIFICATION_SCHEMA = {
  id: 'id',
  description: 'specification',
  isSelected: 'isSelected',
};

export function parseFluid(data: any): Fluid | null {
  return parseEntity(data, FLUID_SCHEMA, Fluid);
}

export function parseFluids(data: any): Array<Fluid> {
  return parseEntities(data, parseFluid);
}

export function parseReplenishedFluids(data: any): Array<Fluid> {
  return parseEntities(data, REPLENISHED_SCHEMA, Fluid);
}

export function parseSpecifications(data: any): Array<FluidSpecification> {
  return parseEntities(data, SPECIFICATION_SCHEMA, FluidSpecification);
}

export function formatFluidData(data: FluidData): object {
  return {
    quantity: data.quantity,
    specificationId: data.specification?.id ?? null,
    productCode: data.productCode,
  };
}